import React from 'react';

const AboutUsSection = () => {
  return (
    <section id="tentang" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Tentang Kami</h2>
        <p className="mt-4 text-lg text-gray-600">
          Kami adalah penyedia layanan AC yang berdedikasi untuk memberikan solusi pendinginan terbaik bagi rumah dan bisnis Anda. Dengan pengalaman bertahun-tahun, tim teknisi kami yang profesional dan bersertifikat siap melayani berbagai kebutuhan AC Anda, mulai dari instalasi, perawatan, perbaikan, hingga pengisian freon.
        </p>
        <p className="mt-2 text-lg text-gray-600">
          Komitmen kami adalah kepuasan pelanggan. Kami menggunakan peralatan modern dan suku cadang berkualitas tinggi untuk memastikan setiap pekerjaan dilakukan dengan standar tertinggi. Percayakan kebutuhan AC Anda kepada kami untuk udara yang lebih bersih, sejuk, dan nyaman.
        </p>
      </div>
    </section>
  );
};

export default AboutUsSection;